<div mat-dialog-content>
  <p>Are you sure want to remove this product from your cart?</p>
</div>
<div mat-dialog-actions class="pb-4">
  <button mat-button mat-dialog-close>No Thanks!</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes, Delete it!</button>
</div>